<div class="photo-grid"></div>
<div class="floating-shapes">
  <div class="shape1"></div>
  <div class="shape2"></div>
</div>

<app-header></app-header>

<main class="main-content">
  <router-outlet></router-outlet>
</main>
